import config from 'netxcore@netx/core-cart/config';

Object.assign(config, {
	SHARE_SYNC_IMMEDIATE: true,
});

export default config;
